import styled from '@emotion/styled/macro';

import { PaginationItem, TableCell, TableHead } from '@mui/material';

export const TableHeadStyled = styled(TableHead)`
  background: hsla(234, 8%, 23%, 0.1);
`;

export const HeaderCellStyled = styled(TableCell)`
  padding: 8px 14px;
  border: 0;
  font-size: ${12 / 16}rem;
  @media (min-width: 800px) {
    padding: 8px 30px;
  }
`;

export const HeaderCellContent = styled.div`
  padding: 0;
`;

export const TableCellStyled = styled(TableCell)`
  max-width: 190px;
  padding: 10px 14px;
  border: 0;
  font-size: ${14 / 16}rem;
  color: var(--brand-black);
  @media (min-width: 800px) {
    max-width: 300px;
    padding: 10px 30px;
  }
`;

export const TableCellContent = styled.div`
  max-width: 300px;
  padding: 0;
  @media (min-width: 1040px) {
    &[data-wide='true'] {
      min-width: 300px;
    }
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-self: flex-end;
  flex-direction: column;
  gap: 6px;
  padding: 0 30px;
  align-items: center;
`;

export const PaginationInfo = styled.span`
  font-size: ${12 / 16}rem;
  color: hsla(234, 8%, 23%, 0.8);
`;

export const PaginationItemStyled = styled(PaginationItem)`
  padding: 22px 20px;
  background: rgba(54, 55, 64, 0.05);
  border-radius: 6px;
  svg {
    width: 24px;
    height: 24px;
  }
`;
